(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
console.log("Hello");

function initSlickSlideshowV1(container) {
  if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
    return false;
  }
  var $slider = jQuery(container).find('.slick-side-h1');
  if (!$slider.length) return false;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: '.slick-side-h1',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });
  return true;
}

function waitForSlickAndInit(container, retries) {
  var ok = initSlickSlideshowV1(container);
  if (!ok && retries > 0) {
    setTimeout(function() {
      waitForSlickAndInit(container, retries - 1);
    }, 100);
  } else if (!ok) {
    console.error('Slick Slider failed to load after retries.');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  waitForSlickAndInit(document, 50); // retry up to ~5 seconds
});

document.addEventListener('shopify:section:load', function(event) {
  waitForSlickAndInit(event.target, 50);
});

document.addEventListener('shopify:section:reorder', function() {
  waitForSlickAndInit(document, 50);
});

document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      var $slider = jQuery('.slick-side-h1');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickPause');
        $slider.slick('refresh');
        $slider.slick('slickPlay');
      }
    }
  }
});

var slickResizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(slickResizeTimer);
  slickResizeTimer = setTimeout(function() {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      var $slider = jQuery('.slick-side-h1');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }
  }, 200);
});

  } catch(e) { console.error(e); }
})();
})();
